<script>
export default {
  name: 'StyleCreator',

  render: function(createElement) {
    return createElement('style', this.$slots.default);
  }
};
</script>
